import React, { useEffect, useState } from "react";
import { usePrimaryOrganization } from "../../../hooks";
import {
  PrivacyNoticeChecklistItems,
  usePrivacyNoticeChecklistItems,
} from "../PrivacyNoticeChecklistItems";
import { StandardPageWrapper } from "../../../components/layout/StandardPageWrapper";
import { Loading } from "../../../components";
import { TopNavigationBreadcrumb } from "../../../components/privacyCenter/TopNavigationBreadcrumb";
import { useSurvey } from "../../../../common/hooks/api/useSurvey";
import { useOnboardingProgress } from "../../../../common/hooks/useOnboardingProgress";
import {
  COLORADO_BIOMETRIC_IDENTIFIERS_QUESTION_SLUG,
  COLORADO_EMPLOYEES_QUESTION_SLUG,
  HR_SURVEY_NAME,
} from "../../../surveys/hrSurvey";
import { usePrivacyCenter } from "../../../hooks/usePrivacyCenter";
import { PrivacyCenterUrls } from "../../../util/privacyCenterUtil";

export const HRNoticesInstructionsPage = () => {
  const [org] = usePrimaryOrganization();

  const [readyToRender, setReadyToRender] = useState(false);

  const { checklistProps, ready } = usePrivacyNoticeChecklistItems(org.devInstructionsId);
  const { answers: hrAnswers, request: hrSurveyRequest } = useSurvey(org.id, HR_SURVEY_NAME);
  const [privacyCenter, privacyCenterRequest] = usePrivacyCenter(org.id);
  const [onboardingProgress, onboardingProgressRequest] = useOnboardingProgress(org.id);

  useEffect(() => {
    if (
      ready &&
      hrSurveyRequest.success &&
      privacyCenterRequest.success &&
      onboardingProgressRequest.success
    ) {
      setReadyToRender(true);
    }
  }, [
    hrSurveyRequest.success,
    onboardingProgressRequest.success,
    privacyCenterRequest.success,
    ready,
  ]);

  if (!readyToRender) {
    return (
      <StandardPageWrapper>
        <Loading />
      </StandardPageWrapper>
    );
  }

  const qualifiesForColoradoBiometricNotice =
    hrAnswers?.[COLORADO_EMPLOYEES_QUESTION_SLUG] === "true" &&
    hrAnswers?.[COLORADO_BIOMETRIC_IDENTIFIERS_QUESTION_SLUG] === "true";
  const hasCompletedColoradoBiometricNotice =
    onboardingProgress?.hrCenterOnboardingProgress.isHrColoradoEmployeeBiometricNoticeComplete ===
    true;
  const coloradoBiometricNoticeUrl = privacyCenter
    ? PrivacyCenterUrls.getColoradoEmployeeBiometricNoticeUrl(privacyCenter)
    : undefined;

  return (
    <StandardPageWrapper>
      <TopNavigationBreadcrumb source="HR Center" title="HR Notices" />

      {checklistProps?.notices && (
        <PrivacyNoticeChecklistItems
          {...checklistProps}
          stayCompliant={true}
          isHr={true}
          isPublicView={false}
          showColoradoBiometricNoticeEditor={qualifiesForColoradoBiometricNotice}
          hasCompletedColoradoBiometricNotice={hasCompletedColoradoBiometricNotice}
          coloradoBiometricNoticeUrl={coloradoBiometricNoticeUrl}
        />
      )}
    </StandardPageWrapper>
  );
};
